import { useQuery } from 'react-query';

import { getClient } from 'api/clients/getClient';

export const useGetClient = (id?: number) => {
  const { data, refetch, isLoading } = useQuery('client', () => getClient(id || 0), {
    enabled: id ? true : false,
    refetchOnWindowFocus: false,
  });

  return { data, refetch, isLoading };
};

export default useGetClient;
